import './ClubOneHint.scss'

import { Icon, Text } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'

export default function ClubOneHint({ containerWidth, hintText }) {
  return (
    <span className="club-one-hint">
      <Icon className="icon-question" type="question" />
      <Text className="hint" style={{ width: `${containerWidth}px` }} weight="medium">
        <p dangerouslySetInnerHTML={{ __html: hintText }} />
      </Text>
    </span>
  )
}

ClubOneHint.propTypes = {
  containerWidth: PropTypes.number.isRequired,
  hintText: PropTypes.string.isRequired
}
